import PinnedPanelContainer from './container';
import PinnedPanel from './PinnedPanel';

export { PinnedPanel };
export default PinnedPanelContainer;
